import { ApolloLink, HttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

const graphQLUri = "/query";

const buildLink = ({
  getCsrfToken,
  setCsrfToken,
}: {
  getCsrfToken: () => string | null;
  setCsrfToken: (token: string) => void;
}) => {
  const authLink = setContext((_, { headers }) => {
    // get the CSRF token from local storage if it exists
    const token = getCsrfToken();
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        "X-CSRF-Token": token,
      },
    };
  });

  const refreshCsrfTokenLink = new ApolloLink((operation, forward) => {
    return forward(operation).map((response) => {
      const {
        response: { headers },
      } = operation.getContext();

      if (headers) {
        const token = headers.get("X-Refresh-CSRF-Token");

        if (token) {
          setCsrfToken(token);
        }
      }

      return response;
    });
  });

  const link = from([
    authLink,
    refreshCsrfTokenLink,
    new HttpLink({
      uri: graphQLUri,
    }),
  ]);

  return link;
};
export default buildLink;
